import { render } from "./SpecificationPage.vue?vue&type=template&id=690bcf68"
import script from "./SpecificationPage.vue?vue&type=script&lang=js"
export * from "./SpecificationPage.vue?vue&type=script&lang=js"

import "./SpecificationPage.vue?vue&type=style&index=0&id=690bcf68&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__